import styled from 'styled-components';

export const UiFooter = styled.div`
	background-color: #000;
`;

export const UiRow = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 0;
	font-size: 0.675rem;
	font-family: ${({ theme }) => theme.typography.fontFamily};
	color: #fff;
`;

export const UiContent = styled.div`
	padding: 0 1rem;
`;

export const UiLink = styled.div`
	margin: auto;
	font-size: 1.2rem;
	text-decoration: underline;
	cursor: pointer;
`;
